export default function PhilosophySection() {
  return (
    <section className="w-full bg-background-50">
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-[40%] relative min-h-[350px] lg:min-h-[600px]">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20minimal%20geometric%20grid%20pattern%20on%20soft%20sage%20green%20background%2C%20clean%20modern%20aesthetic%2C%20subtle%20technical%20precision%20feel%2C%20no%20text%20no%20people%2C%20architectural%20line%20drawing%20style%2C%20delicate%20structure%2C%20calm%20atmospheric%20composition%2C%20high%20resolution%20editorial%20quality&width=700&height=900&seq=philosophy-deco-tubi-2026&orientation=portrait"
            alt="Abstract geometric grid pattern representing technical precision"
            title="TubiConsult AB technical precision"
            className="absolute inset-0 w-full h-full object-cover rounded-r-3xl lg:rounded-r-none"
          />
        </div>

        <div className="w-full lg:w-[60%] px-6 md:px-12 lg:px-16 py-16 md:py-20 flex flex-col justify-center">
          <p className="text-xs md:text-sm uppercase tracking-[0.15em] text-foreground-500 mb-6">
            Our Approach
          </p>

          <h3 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight tracking-tight">
            Engineering
            <br />
            <span className="text-foreground-400">with purpose</span>
          </h3>

          <div className="mt-12">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-xl">
              We follow modern software engineering practices including clean
              architecture, performance optimization, and user-centered design.
              Every project is approached with a focus on maintainability and
              long-term stability. The team emphasizes continuous innovation,
              improvement of development workflows, and adoption of up-to-date
              engineering standards to deliver reliable and future-ready
              solutions. We actively explore new technologies and evolve our
              internal processes to maintain high technical excellence.
            </p>
          </div>

          <div className="mt-10">
            <span className="text-base md:text-lg font-semibold text-foreground-900">
              &mdash; The TubiConsult AB Engineering Team
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}